// The six agencies carried by the durable CompanyAgencyApproval scalar group
// (Accounts, DEV-3609 / DEV-3618). `key` is the camelCase prefix shared by the
// model's `<key>Approved` / `<key>Id` / `<key>ApprovalDate` fields. Fannie/Freddie
// collapse into a single "Conventional (FNMA/FHLMC)" row on the homepage card.
const APPROVAL_AGENCY_FIELD = {
  FANNIE_MAE: 'fannieMae',
  FREDDIE_MAC: 'freddieMac',
  GINNIE_MAE: 'ginnieMae',
  FHA: 'fha',
  VA: 'va',
  USDA: 'usda',
};

export const AgencyFieldSuffix = {
  APPROVED: 'Approved',
  APPROVAL_DATE: 'ApprovalDate',
};

// Homepage agency rows in display order. Conventional is the OR of the two GSEs.
export const APPROVAL_AGENCY_ROWS = [
  {
    id: 'agency-conventional',
    label: 'Conventional (FNMA/FHLMC)',
    agencyKeys: [APPROVAL_AGENCY_FIELD.FANNIE_MAE, APPROVAL_AGENCY_FIELD.FREDDIE_MAC],
  },
  { id: 'agency-fha', label: 'FHA', agencyKeys: [APPROVAL_AGENCY_FIELD.FHA] },
  { id: 'agency-va', label: 'VA', agencyKeys: [APPROVAL_AGENCY_FIELD.VA] },
  { id: 'agency-usda', label: 'USDA', agencyKeys: [APPROVAL_AGENCY_FIELD.USDA] },
  { id: 'agency-ginnie', label: 'Ginnie Mae', agencyKeys: [APPROVAL_AGENCY_FIELD.GINNIE_MAE] },
];

export const ApprovalScopeGroupId = {
  CHANNELS: 'group-channels',
  AGENCIES: 'group-agencies',
};

export const APPROVAL_SCOPE_GROUP_TITLE = {
  [ApprovalScopeGroupId.CHANNELS]: 'Channels',
  [ApprovalScopeGroupId.AGENCIES]: 'Agency / program mix',
};

export const APPROVAL_SCOPE_FOOTER_PREFIX = 'Scoped to your approval on file';
export const APPROVAL_SCOPE_FOOTER_NO_DATE = `${APPROVAL_SCOPE_FOOTER_PREFIX} · effective date on file`;
export const APPROVAL_SCOPE_EMPTY_MESSAGE =
  'Your approval scope isn’t on file yet. Contact your account executive to get started.';
